import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { companyInfo } from '../data/mock';
import ChatWidget from '../components/common/ChatWidget';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <main className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-slate-900 mb-8">Allgemeine Geschäftsbedingungen</h1>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100 space-y-8">
              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 1 Geltungsbereich</h2>
                <p className="text-slate-600">
                  Diese Allgemeinen Geschäftsbedingungen gelten für alle Geschäftsbeziehungen zwischen der 
                  {companyInfo.legal.company} (nachfolgend "Vermittler") und dem Kunden. Es gilt die zum 
                  Zeitpunkt des Vertragsschlusses gültige Fassung.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 2 Leistungsbeschreibung</h2>
                <p className="text-slate-600 mb-4">
                  Der Vermittler erbringt Dienstleistungen im Bereich der Finanzierungsvermittlung. Dies umfasst:
                </p>
                <ul className="list-disc list-inside text-slate-600 space-y-2">
                  <li>Analyse des Finanzierungsbedarfs des Kunden</li>
                  <li>Vergleich von Finanzierungsangeboten verschiedener Kreditinstitute</li>
                  <li>Vermittlung von Kreditverträgen zwischen dem Kunden und dem Kreditinstitut</li>
                  <li>Beratung während des gesamten Finanzierungsprozesses</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 3 Unabhängigkeit</h2>
                <p className="text-slate-600">
                  Der Vermittler ist unabhängiger Finanzierungsvermittler und an kein Kreditinstitut gebunden. 
                  Die Beratung erfolgt ausschließlich im Interesse des Kunden. Der Vermittler vergleicht 
                  Angebote von mehr als 500 Partnerbanken.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 4 Vergütung</h2>
                <p className="text-slate-600 mb-4">
                  Die Beratungsleistung für den Kunden ist kostenlos. Der Vermittler erhält eine Provision 
                  vom vermittelnden Kreditinstitut. Diese Provision hat keinen Einfluss auf die Höhe der 
                  Finanzierungskonditionen für den Kunden.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 5 Mitwirkungspflichten des Kunden</h2>
                <p className="text-slate-600 mb-4">Der Kunde ist verpflichtet:</p>
                <ul className="list-disc list-inside text-slate-600 space-y-2">
                  <li>Vollständige und wahrheitsgemäße Angaben zu machen</li>
                  <li>Angeforderte Unterlagen zeitnah bereitzustellen</li>
                  <li>Änderungen seiner finanziellen Situation unverzüglich mitzuteilen</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 6 Datenschutz</h2>
                <p className="text-slate-600">
                  Der Vermittler erhebt, speichert und verarbeitet personenbezogene Daten des Kunden nur 
                  im Rahmen der geltenden Datenschutzgesetze. Details hierzu finden Sie in unserer 
                  Datenschutzerklärung.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 7 Haftung</h2>
                <p className="text-slate-600 mb-4">
                  Der Vermittler haftet für Schäden nur bei Vorsatz und grober Fahrlässigkeit. Die Haftung 
                  für leichte Fahrlässigkeit ist ausgeschlossen, es sei denn, es werden wesentliche 
                  Vertragspflichten verletzt.
                </p>
                <p className="text-slate-600">
                  Die endgültige Kreditentscheidung liegt ausschließlich beim jeweiligen Kreditinstitut. 
                  Der Vermittler kann keine Zusage für eine Finanzierung garantieren.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 8 Widerrufsrecht</h2>
                <p className="text-slate-600">
                  Der Kunde hat das Recht, einen geschlossenen Vermittlungsvertrag innerhalb von 14 Tagen 
                  ohne Angabe von Gründen zu widerrufen. Die Widerrufsfrist beginnt mit dem Tag des 
                  Vertragsschlusses.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">§ 9 Schlussbestimmungen</h2>
                <p className="text-slate-600 mb-4">
                  Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand für alle Streitigkeiten 
                  aus diesem Vertragsverhältnis ist München, sofern der Kunde Kaufmann ist.
                </p>
                <p className="text-slate-600">
                  Sollten einzelne Bestimmungen dieser AGB unwirksam sein, berührt dies die Wirksamkeit 
                  der übrigen Bestimmungen nicht.
                </p>
              </section>

              <p className="text-slate-500 text-sm pt-4 border-t border-slate-200">
                Stand: August 2025
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <ChatWidget />
    </div>
  );
};

export default TermsPage;
